import React from 'react'
import styled from 'styled-components'
import { useStaticQuery, graphql } from 'gatsby'

import {information_data} from '../../data/aboutData'
import AboutLangItem from '../../atoms/AboutLangItem'

export default () => {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter:{relativePath: {regex: "/about_la_/"}}) {
        nodes {
          childImageSharp {
            fluid {
              src
            }
          }
        }
      }
    }
  `)

  const {nodes} = data.allFile
  const selectCorrectImg = (lang) => {
    const target_node = nodes.filter((node) => node?.childImageSharp?.fluid?.src?.includes(lang))
    return <AboutLangItem key={lang} lang={lang} img={target_node[0].childImageSharp.fluid.src}/>
  }

  selectCorrectImg('korean')

  return (
    <Container>
      <MainTitle>Languages</MainTitle>
      <LangList>
        {information_data.languages.map((lang) => selectCorrectImg(lang))}
      </LangList>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 3rem 2rem;
  background-color: ${props => props.theme.green};
  @media(min-width: 1100px) {
    padding: 3rem 10% 3rem 16%;
  }
  @media(min-width: 1300px) {
    position: relative;
    top: -3rem;
    padding: 4rem 10% 4rem 21%;
  }
`
const MainTitle = styled.h2`
  width: 100%;
  color: ${props => props.theme.beige};
  font-family: ELEPHNT;
  border-left: 3px solid ${props => props.theme.beige};
  padding: 0 1rem;
  margin-bottom: 2rem;
  letter-spacing: 0.2rem;
  @media(min-width: 900px) {
    font-size: 2rem;
    margin-left: 3rem;
  }
  @media(min-width: 1100px) {
  }
  @media(min-width: 1300px) {
  }
`
const LangList = styled.div`
  display: flex;
  flex-direction: column;
  @media(min-width: 900px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`